import { z } from 'zod';

export const CabinetTemplateSchema = z.object({
  id: z.string().uuid(),
  code: z.string(),
  name: z.string(),
  cabinet_type: z.string(),
  default_width: z.number(),
  default_height: z.number(),
  default_depth: z.number(),
  num_doors: z.number().int(),
  num_drawers: z.number().int(),
  num_shelves: z.number().int(),
  has_back: z.boolean(),
  construction_method_id: z.string().uuid().nullable(),
  construction_notes: z.string().nullable(),
  face_component_config: z.string().default('{}'),
  active: z.boolean().default(true),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
  template_hardware: z.array(z.object({
    id: z.string().uuid(),
    template_id: z.string().uuid(),
    hardware_id: z.string().uuid(),
    quantity_per_cabinet: z.number().int(),
    hardware: z.any().optional(),
  })).optional(),
});

export const CreateCabinetTemplateSchema = z.object({
  code: z.string().min(1, 'Code is required'),
  name: z.string().min(1, 'Name is required'),
  cabinet_type: z.string().min(1, 'Cabinet type is required'),
  default_width: z.number(),
  default_height: z.number(),
  default_depth: z.number(),
  num_doors: z.number().int().default(0),
  num_drawers: z.number().int().default(0),
  num_shelves: z.number().int().default(0),
  has_back: z.boolean().default(true),
  construction_method_id: z.string().uuid().nullable().optional(),
  construction_notes: z.string().nullable().optional(),
  face_component_config: z.string().default('{}'),
  active: z.boolean().default(true),
});

export const UpdateCabinetTemplateSchema = CreateCabinetTemplateSchema.partial();

export const TemplateHardwareSchema = z.object({
  id: z.string().uuid(),
  template_id: z.string().uuid(),
  hardware_id: z.string().uuid(),
  quantity_per_cabinet: z.number().int().default(1),
});

export const CreateTemplateHardwareSchema = z.object({
  hardware_id: z.string().uuid(),
  quantity_per_cabinet: z.number().int().default(1).optional(),
});

export type CabinetTemplate = z.infer<typeof CabinetTemplateSchema>;
export type CreateCabinetTemplate = z.infer<typeof CreateCabinetTemplateSchema>;
export type UpdateCabinetTemplate = z.infer<typeof UpdateCabinetTemplateSchema>;
export type TemplateHardwareType = z.infer<typeof TemplateHardwareSchema>;
export type CreateTemplateHardware = z.infer<typeof CreateTemplateHardwareSchema>;
